import type { ComponentProps } from 'react'
import { MARK_PATHS, MARK_VIEW_BOX } from './xendrel-geometry'

/**
 * Xendrel brand mark — four chevrons closing in on a centre, forming an X.
 *
 * The viewBox is square, so any `size-*` works. Fills with `currentColor`, so
 * it inherits the surrounding text color. Decorative by default; other svg
 * props pass through, so it can be rendered where a lucide icon would be.
 */
export function XendrelMark(props: Omit<ComponentProps<'svg'>, 'children' | 'fill' | 'viewBox'>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      {...props}
      viewBox={MARK_VIEW_BOX}
      fill="currentColor"
    >
      {MARK_PATHS.map(d => (
        <path key={d} d={d} />
      ))}
    </svg>
  )
}
